import {Controller} from "@hotwired/stimulus"
import * as notifications from './../../front/websocket'

export default class extends Controller {

    connect() {
        setTimeout(notifications.startNotification, 0)
    }

}